import { Component } from '@angular/core';

@Component({
  selector: 'app-unavailable',
  templateUrl: './check-version.page.html',
  styleUrls: ['./check-version.page.scss']
})
export class CheckVersionPage {

  constructor() {}
}
